import { EvmItemType } from '@/service/EVM/types';
import type { EvmItemTypeAbi } from '@/service/EVM/config/types';

export const isEvmErc721 = (itemType: EvmItemType) => itemType === EvmItemType.ERC721 || itemType === EvmItemType.ERC721_WITH_CRITERIA;

export const isEvmErc1155 = (itemType: EvmItemType) => itemType === EvmItemType.ERC1155
    || itemType === EvmItemType.ERC1155_WITH_CRITERIA;

export function isEvmItemTypeAbi(value: EvmItemType): value is EvmItemTypeAbi {
    return value === EvmItemType.ERC721 || value === EvmItemType.ERC1155;
}
